export enum VideoType {
  Regular = 1,
  Panoramic = 2,
  Hero = 3,
  Short = 4,
}
